import { Link } from 'react-router-dom';
import { getRelatedArticles, type Article } from '@/mocks/articles';

interface RelatedArticlesProps {
  currentId: string;
  categorySlug: string;
}

export default function RelatedArticles({ currentId, categorySlug }: RelatedArticlesProps) {
  const related = getRelatedArticles(currentId, categorySlug, 4);

  if (related.length === 0) return null;

  return (
    <div className="border-t border-background-200 pt-8">
      <h3 className="text-xl font-bold text-foreground-950 font-heading mb-6">
        相关爆料
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {related.map((article: Article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group cursor-pointer"
          >
            <div className="relative h-36 rounded-lg overflow-hidden mb-3">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <h4 className="font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors font-heading text-sm line-clamp-2">
              {article.title}
            </h4>
            <span className="text-xs text-foreground-500 mt-1 block">{article.publishedAt}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}